import { useState } from 'react'
import { Body, Box, H3, H4, Icon } from '../widgets'
import { PriceSelect, SubscriptionFeatures } from './'
import { typePricing } from '../../lookups'
import './PriceCard.scss'

export const PriceCard = ({ name, startingCost, description, defaultTeam, selected, onSubscriptionSelected, showPricing,
                            type, children, ...props }) => {
  const [teamsSelected, setTeamsSelected] = useState(defaultTeam || 0)
  const [subscription, setSubscription] = useState(typePricing[type][0].id)

  const teamOptionSelected = (value) => {
    setTeamsSelected(value)
    setSubscription(typePricing[type][value].id)
    onSubscriptionSelected(typePricing[type][value].id)
  }

  const resetSubscription = () => {
    if(!selected){
      onSubscriptionSelected(subscription)
    }
  }

  return (
    <Box
      className="price-card"
      column
      gap={16}
      background={selected ? 'var(--blue)' : 'black'}
      radius={16}
      p={16}
      cursor="pointer"
      onClick={resetSubscription}
      {...props}
    >
      <Box justifyContent="space-between">
        <H4 align="left">{name}</H4>
        <Box mt={4}>
          <Icon icon={selected ? 'RadioActive' : 'RadioInactive'} />
        </Box>
      </Box>

      <Box>
        <Box className="mobile-only" column gap={8}>
          {startingCost &&
            <Box column gap={4}>
              <H3 align="left" color="white">{startingCost}</H3>
              <Body lineHeight="100%" size={12} align="left" color="white">Starting from</Body>
            </Box>
          }

          {description &&
            <Body lineHeight="100%" size={16} weight={600} alt align="left" color="white">
              {description}
            </Body>
          }
        </Box>

        <Box className="desktop-only" fullWidth column gap={16}>
          {showPricing &&
            <PriceSelect value={teamsSelected} onTeamOptionSelected={teamOptionSelected} pricing={typePricing[type]} />
          }
          <SubscriptionFeatures subscriptionType={type} />
        </Box>
      </Box>

      {children}
    </Box>
  )
}